import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CompanyGig } from "model/Gig";
import { Color } from "config/colors";
import { CustomIcon } from "components/icon/customIcon.component";
import { Options } from "./gigs.styled";
import { CloseGigModal } from "./closeGigModal.component";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import { Api } from "services/api/api.service";
import { TimeReportStatus } from "model/TimeReport";
import { useAlertStore } from "stores/alertStore/alertStore";
import { WorkerWithUrl } from "model/Company";
import {
  IconCircularContainer,
  IconsContainer,
} from "../../shared/actionIcons.styled";

type Props = {
  gigData: CompanyGig;
  onGigClosed?: (gig: CompanyGig) => void;
  workerWithImageUrl?: WorkerWithUrl[];
};

export const GigOptions: React.FC<Props> = ({ gigData, onGigClosed }) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const [, , alertDispatch] = useAlertStore();
  const [companyState] = useCompanyStore();

  const handleCloseGig = () => {
    if (companyState.company?.id) {
      Api()
        .company.timeReport.getGigTimeReports(
          companyState.company?.id,
          gigData.id
        )
        .then((res) => {
          if (
            res.data.find(
              (timeReport) => timeReport.status !== TimeReportStatus.NEW
            )
          ) {
            alertDispatch({
              type: "SHOW_ALERT",
              payload: {
                icon: "alert",
                title: "",
                message: t("GigsCompany.ThisGigHasConnectedTimeReports"),
              },
            });
          } else {
            setModalOpen(true);
          }
        });
    }
  };

  return (
    <>
      <Options>
        <IconsContainer>
          <IconCircularContainer
            onClick={() => {
              handleCloseGig();
            }}
          >
            <CustomIcon
              className="icon"
              name="trashcan"
              size="20px"
              padding="2px"
              color={Color.White}
            />
          </IconCircularContainer>
        </IconsContainer>
      </Options>
      <CloseGigModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        gigData={gigData}
        onGigClosed={onGigClosed}
      />
    </>
  );
};
